import gql from 'graphql-tag';
export const StatFeatureStaffLeaveSources = gql `
    fragment StatFeatureStaffLeaveSources on StaffLeaveSourcesFeatureSettingsFlags {
        isEnabled
    }
`;
